(function (Drupal, $) {
  'use strict';

  /**
   * TV Social Video behavior.
   *
   * @type {{attach: Drupal.sticky_bar.attach}}
   */
  Drupal.behaviors.tv_social_video = {
    attach: function (context, settings) {
      once('tv-social-video', '.paragraph--type--tv-social-video .tv-paragraph--poster').forEach(function (element) {
        var $poster = $(element);
        $poster.on('click', function() {
          $(this).hide();
          const youtubeIframe = $(this).closest('.tv-paragraph--video').find('iframe').get(0);
          if (youtubeIframe.src.indexOf('autoplay=0') !== -1) {
            youtubeIframe.src = youtubeIframe.src.replace('autoplay=0', 'autoplay=1');
          }
          else if (youtubeIframe.src.indexOf('autoplay=1') === -1) {
            youtubeIframe.src += '?autoplay=1';
          }
        });
      });
    }
  };

} (Drupal,  jQuery));
